import { type RequestPayload, router } from "@inertiajs/core";
import { EducationConfigForm } from "../../../components/reportConfig/form/EducationConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { EducationConfiguration } from "../../../models/reportConfigs/educationConfiguration";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type EducationConfigEditProps = {
  education_config: EducationConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
};

export default function EducationConfigEdit({ year_contexts, groups, education_config }: EducationConfigEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);
  return (
    <ContentShell
      title={`Bildungsbericht-Vorlage ${education_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <EducationConfigForm
        semester={education_config.report_type === ReportType.EDUC1 ? "1" : "2"}
        saveButtonLabel="Speichern"
        groups={groups}
        yearContexts={year_contexts}
        onSubmit={onSubmit}
        educationConfig={education_config}
      />
    </ContentShell>
  );
}
